/* @flow */
import PropTypes from "prop-types";

import React from "react";
import { isEmpty } from "shared/src/utils/util";

const FALLBACK_TITLE = "M:SHOP";

/**
 * Sets the document title when it is mounted.
 */
class DocumentTitle extends React.Component<{
    [x: string]: any;
}> {
    static propTypes = {
        k: PropTypes.string.isRequired
    };

    static contextTypes = {
        intl: PropTypes.object
    };

    componentDidMount() {
        this.setPageTitle();
    }

    componentDidUpdate() {
        this.setPageTitle();
    }

    componentWillUnmount() {
        const title = this.context.intl.formatMessage({ id: "EX_BROWSER_TITLE" });
        document.title = title || FALLBACK_TITLE;
    }

    setPageTitle = () => {
        let kString;
        const { k, ...args } = this.props;
        if (Array.isArray(k)) {
            kString = this.props.k.join(".") || "";
        } else {
            kString = this.props.k || "";
        }
        let text = kString;
        try {
            if (!isEmpty(args)) {
                text = this.context.intl.formatMessage({ id: kString }, args);
            } else {
                text = this.context.intl.formatMessage({ id: kString });
            }
        } catch (e) {
            console.warn("Message key not found", kString, e);
        }
        document.title = text || FALLBACK_TITLE;
    };

    render(): any {
        return <span />;
    }
}

export default DocumentTitle;
